<template>
    <div class="data-table w-100">
        <div class="table-responsive">
            <table class="table mb-0">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Número</th>
                        <th>Proveedor</th>
                        <th class="text-right">Monto</th>
                        <th class="text-right">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(po, index) in payorderListFiltered" :key="index">
                        <td>{{ formatoDate2Fecha(po.created_at) }}</td>
                        <td><span class="data-table__primary">{{ po.number }}</span></td>
                        <td>{{ po.provider_name }}</td>
                        <td class="text-right">{{ formatoDinamicoMoneda(po.total) }}</td>
                        <td class="text-right">
                            <div class="table-action-group">
                                <a class="table-action-btn" :href="'/compras/detalle-orden-de-pago/' + po.id" title="Ver detalle">
                                    <i class="bi bi-eye"></i>
                                </a>
                                <button type="button" class="table-action-btn" title="Descargar PDF" @click="getPDF(po.id, po.number)">
                                    <i class="bi bi-filetype-pdf"></i>
                                </button>
                                <button type="button" class="table-action-btn" title="Cancelar pago" @click="cancelPayorder(po.pac_id)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="payorderListFiltered.length === 0">
                        <td colspan="5" class="data-table__empty">Sin órdenes de pago para mostrar</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- PAGINACION -->
        <div class="data-table__footer">
            <div class="data-table__info">
                Página {{ page }} de {{ totalPages }}
            </div>
            <ul class="data-table__pagination">
                <li class="page-item" :class="{ disabled: page === 1 }">
                    <a class="page-link" href="#" @click.prevent="prevPage()"><i class="bi bi-chevron-left"></i></a>
                </li>
                <li v-if="(page - (pageInterval / 2)) > 0" class="page-item">
                    <a class="page-link" href="#" @click.prevent="prevPage()">…</a>
                </li>
                <template v-for="index in totalPages">
                    <li v-if="inIntervalPage(index)" :key="index" class="page-item" :class="{ active: page === index }">
                        <a class="page-link" href="#" @click.prevent="changePage(index)">{{ index }}</a>
                    </li>
                </template>
                <li v-if="totalPages > (page + (pageInterval / 2))" class="page-item">
                    <a class="page-link" href="#" @click.prevent="nextPage()">…</a>
                </li>
                <li class="page-item" :class="{ disabled: page >= totalPages }">
                    <a class="page-link" href="#" @click.prevent="nextPage()"><i class="bi bi-chevron-right"></i></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import formatDateMixin from "../../../mixins/formatDateMixin";
import formatMoneyMixin from "../../../mixins/formatMoneyMixin";
import myaxios from 'axios';

export default {
    props: ['provider','fromDate','toDate','watchTarget'],
    mixins: [formatDateMixin,formatMoneyMixin],
    data() {
        return {
            payorderList:[],
            poFilter:'',
            page:1,
            rowCount:9,
            totalItems:0,
            totalPages:1,
            pageInterval:22,
        }
    },
    mounted(){
        this.getPayorderList();
    },
    computed: {
        payorderListFiltered:{
            get: function () {
                let vm = this;
                return this.payorderList.filter(e => e.number.includes(vm.poFilter));
            }
        }
    },
    methods: {
        getPayorderList(){
            var vm= this;
            var outdata = {
                'provider_id': vm.provider,
                'fromDate':vm.fromDate,
                'toDate':vm.toDate,
                'page':vm.page,
                'rowCount':vm.rowCount
            };
            axios.post('/api/payments/getPayorders', outdata)
            .then(response => {
                if(response.data) {
                vm.payorderList = response.data.data.list;
                vm.totalItems=response.data.data.totalItems;
              }
            })
            .catch(error => {
              alert(error);
            })
        },
        cancelPayorder(value){
            this.$emit('cancelPay',value);
        },
        prevPage(){
            this.page = this.page-1;
            this.getPayorderList();
        },
        nextPage(){
            this.page = this.page +1;
            this.getPayorderList();
        },
        changePage(data){
            this.page = data;
            this.getPayorderList();
        },
        inIntervalPage(index){
            if(this.totalPages<=this.pageInterval){return true;}

            let limitprev = this.page - (this.pageInterval/2);
            let limitnext = this.page + (this.pageInterval/2);

            if(limitprev<0){
                limitprev=0;
                limitnext=this.pageInterval;
            }

            if(index>limitprev && index<limitnext){
                return true;
            }

            return false;
        },
        getPDF(id, payorderNumber){
            axios.get('/api/payments/poPDF/' + id)
            .then(res => {
                const uninterceptedAxiosInstance = myaxios.create();
                uninterceptedAxiosInstance.get(res.data, { responseType: 'blob' })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const currentDate = new Date();
                    const formattedDate = currentDate.toLocaleDateString().replace(/\//g, '-');
                    const fileName = 'Orden_de_pago_'+ payorderNumber +'_'+this.payorderListFiltered[0].provider_name + '_' + formattedDate + '.pdf';
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = fileName;
                    console.log(link.download);
                    link.click()
                    URL.revokeObjectURL(link.href)
                })
                .catch(error => {
                alert(error);
                })
                .catch(error => {
                    alert(error);
                })
            })    
        }
    },
    watch: {
      'provider': {
          handler: function () {
              this.page=1;
              this.getPayorderList();
            }
      },
      'fromDate': {
          handler: function () {this.getPayorderList();}
      },
      'toDate': {
          handler: function () {this.getPayorderList();}
      },
      'watchTarget': {
          handler: function () {this.getPayorderList();}
      },
      'payorderList':{
          handler: function(){
              this.totalPages = Math.ceil(this.totalItems / this.rowCount);
          }
      }
  },

}
</script>